export class PitrIntervalConfig {
    'intervalMinutes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "intervalMinutes",
            "baseName": "intervalMinutes",
            "type": "PitrIntervalConfigIntervalMinutesEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PitrIntervalConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var PitrIntervalConfigIntervalMinutesEnum;
(function (PitrIntervalConfigIntervalMinutesEnum) {
    PitrIntervalConfigIntervalMinutesEnum[PitrIntervalConfigIntervalMinutesEnum["NUMBER_15"] = 15] = "NUMBER_15";
    PitrIntervalConfigIntervalMinutesEnum[PitrIntervalConfigIntervalMinutesEnum["NUMBER_30"] = 30] = "NUMBER_30";
    PitrIntervalConfigIntervalMinutesEnum[PitrIntervalConfigIntervalMinutesEnum["NUMBER_60"] = 60] = "NUMBER_60";
})(PitrIntervalConfigIntervalMinutesEnum || (PitrIntervalConfigIntervalMinutesEnum = {}));
